module.exports = __webpack_public_path__ + "static/media/BitCoin.b0c1ed12.png";